module.exports = {
  ////  endPoint: 'http://localhost:5003/api',

  //// ImageEndPoint: 'https://testdummy.store/readfiles/',

  ////PUBLIC_KEY_Stripe: 'pk_test_ycme9zRBAh4yF6sGPLWlESFT',

  PUBLIC_KEY_Stripe: 'pk_live_LoKU1FOOAE3E1bCS1A8URwMg',

  serviceCharges: 1.5,
  endPoint: 'https://payment.textilesms.com/api',
  localToken: 'smsEngine',
};
